// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_bc-0";
export var optionCard = "_bc-1";